<template>
  <div class="home-view">
    <Topbar />
    <br>
    <br>
    <div class="container-img mt-3 small pb-5">
      <div class="col-md-6 m-auto mt-5">
        <div class="row">
          <div v-for="(item) in menus" :key="item.idmenusthorpecoletor" class="col-6 ml-0 mr-0 p-0 pl-2 pr-2">

            <div :class="['card-link link mb-3']" :style="'background-color: ' +item.color"
            @click="() => selecionarModulo(item)"
            v-if="item.path">
                <em :class="[item.icone, 'fa-2x', 'mb-2']"></em>
                <br>
                {{ item.nome }}
            </div>

              <router-link  v-if="!item.path"
              class="router-link" :to="'/categoria/'+item.idmenusthorpecoletor">
                <div :class="['card-link link mb-3']" :style="'background-color: ' +item.color">
                    <em :class="[item.icone, 'fa-2x', 'mb-2']"></em>
                    <br>
                    {{ item.nome }}
                </div>
              </router-link>

          </div>
        </div>
      
        <div v-if="this.semPermissao" class="w-100 text-center mt-3">
          <em class="fas fa-exclamation-triangle fa-5x mb-4 text-warning"></em>
          <h6>
            Usuário logado não tem perfil definido para uso do coletor!
            Por favor entre em contato com o administrador do sistema!
          </h6>
        </div>
      </div>
    </div>
    <LogoutModal />
    <FooterBar />
  </div>
</template>


<script>
// @ is an alias to /src
import Topbar from '@/components/Topbar.vue'
import FooterBar from '@/components/FooterBar.vue'
import LogoutModal from '@/components/LogoutModal.vue'
import ViewMixin from './ViewMixin'
import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
import api, { setModuloAtual, getUsername, getPerfil  } from '../services/api'

export default {
  name: 'Home',
  mixins: [
    ViewMixin
  ],
  components: {
    Topbar,
    LogoutModal,
    FooterBar
  },

  data: () => {
    return {
      menus : [],
      semPermissao: false,  
    };
  },

  async mounted() {
    try {
      await this.validarToken();
      await this.getMenus();
    } catch (e) {
      if (e instanceof TokenInvalidoException) {
        this.handleTokenInvalidoException();
      } else if (e instanceof ServerErrorException) {
        alert(e.message);
      } else {
        alert(DEFAULT_ERROR_MESSAGE);
      }      
    }
  },

  methods: {
    getUsername,
    getPerfil,

    async validarToken() {
      this.carregando = true;

      await api.get("/validar-token");

      this.carregando = false;
    },

    async getMenus() {
      this.carregando = true;

      if (getPerfil() == 'null') {
        this.semPermissao = true;
      } else if (!sessionStorage.getItem("menus")) {
        let response = await api.post("/menus", {
          idPerfil: getPerfil()
        });

        let listaMenus = [];
        sessionStorage.setItem("menus", JSON.stringify(response.data));

        for (const menu of response.data) {
          if (menu.idmenupai == null) {
            listaMenus.push(menu);
          }
        }
        this.menus = listaMenus;
      } else {
        
        let listaMenus = [];
        let menus = JSON.parse(sessionStorage.getItem("menus"));

        for (const menu of menus) {
          if (menu.idmenupai == null) {
            listaMenus.push(menu);
          }
        }
        this.menus = listaMenus;
      }

      this.carregando = false;
    },

    selecionarModulo(modulo) {
      setModuloAtual(JSON.stringify(modulo))
      this.$router.push(modulo.path)
    }
  }
}
</script>

<style scoped lang="scss">    

  .home-view {
    height: 100%;
  }

  .container-img {
    height: auto;
    display: flex;
    justify-content: center;
    align-self: center;
  }

  img {    
    filter: drop-shadow(0px 0px 100px rgba(0, 0, 0, 0.2));
    max-width: 80%;
  }

  @media only screen and (min-width: 768px) {
    img {    
      max-width: 40%;
    }
  }

  .card-link {
    padding-left: 4px;
    padding-right: 4px;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
    height: 70px;
    border-radius: 10px 10px;
    color: #FFF;
    text-align: center;
  }

  .router-link {
    text-decoration: none; 
  }

  .link {
    transition: box-shadow .3s;
  }

  .link:hover {
    box-shadow: 0 0 50px rgba(0, 0, 0, 0.255); 
  }
</style>
